export const CHARGES_SUMMARY_ID_PARAMS = [
  "inboundChargesSummaryId",
  "outboundChargesSummaryId",
  "iwoChargesSummaryId",
  "assetChargesSummaryId",
];

// Params the charges-summary modals read alongside the id params.
export const CHARGES_SUMMARY_PARAMS = [...CHARGES_SUMMARY_ID_PARAMS, "assetReplayLogId"];
